(() => {
  const SYMBOLS = /[®™℠]/;
  const SYMBOLS_GLOBAL = new RegExp(SYMBOLS.source, 'g');
  const WRAPPER_CLASS = 'trademark-symbol';

  const SKIP_TAGS = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'INPUT',
    'SELECT',
    'OPTION',
    'CODE',
    'PRE',
    'SVG',
  ]);

  const shouldSkip = (element) => {
    for (let node = element; node; node = node.parentElement) {
      if (SKIP_TAGS.has(node.tagName)) return true;
      if (node.classList && node.classList.contains(WRAPPER_CLASS)) return true;
      if (node.isContentEditable) return true;
      if (node.hasAttribute && node.hasAttribute('data-no-trademark')) return true;
    }
    return false;
  };
  const needsInlineHost = (element) => {
    const display = getComputedStyle(element).display;
    return display.includes('grid') || display.includes('flex');
  };

  const wrap = (textNode) => {
    const parent = textNode.parentElement;
    const text = textNode.nodeValue;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    SYMBOLS_GLOBAL.lastIndex = 0;
    let match;
    while ((match = SYMBOLS_GLOBAL.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }
      const sup = document.createElement('sup');
      sup.className = WRAPPER_CLASS;
      sup.textContent = match[0];
      fragment.appendChild(sup);
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    if (needsInlineHost(parent)) {
      const host = document.createElement('span');
      host.className = 'trademark-host';
      host.appendChild(fragment);
      parent.replaceChild(host, textNode);
      return;
    }

    parent.replaceChild(fragment, textNode);
  };

  const process = (root) => {
    if (!root || root.nodeType === Node.TEXT_NODE) {
      if (root && SYMBOLS.test(root.nodeValue) && !shouldSkip(root.parentElement)) wrap(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        SYMBOLS.test(node.nodeValue) && !shouldSkip(node.parentElement)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    });

    const pending = [];
    let node;
    while ((node = walker.nextNode())) pending.push(node);
    pending.forEach(wrap);
  };

  const observe = () => {
    let queued = [];
    let scheduled = false;

    const flush = () => {
      scheduled = false;
      const batch = queued;
      queued = [];
      batch.forEach(process);
    };

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const added of mutation.addedNodes) {
          if (added.nodeType === Node.ELEMENT_NODE || added.nodeType === Node.TEXT_NODE) {
            queued.push(added);
          }
        }
      }
      if (queued.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  const start = () => {
    process(document.body);
    observe();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
